import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import TableWidget from "../../../../components/tables/TableWidget";
import { RecallSupplierReceiptListInterface } from "../../../../redux/interfaces/recall.interface";
import {
  getRecallReceiptInvoicesTableData,
  recallReceiptInvoicesTableHeader,
} from "./tableConfigs/recallEntryDetailsTableConfig";

function RecallReceiptInvoicesModal({
  receipt,
  handleClose,
}: {
  receipt: RecallSupplierReceiptListInterface;
  handleClose: () => void;
}) {
  return (
    <ModalWrapper
      show
      title={`Facturi receptie ${receipt.receptionFlowId}`}
      modalSize="lg"
      handleClose={handleClose}>
      <TableWidget
        className="[&_thead_th]:text-left"
        tableHeaderData={recallReceiptInvoicesTableHeader}
        tableItemsData={getRecallReceiptInvoicesTableData(
          receipt.invoiceDetails,
        )}
        withTablePagination={false}
        withRouteParams={false}
        emptyTableLabel="Nu exista facturi asociate acestei receptii"
      />
    </ModalWrapper>
  );
}

export default RecallReceiptInvoicesModal;
